import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    Output,
    SimpleChanges
} from '@angular/core';

interface IOptionItem {
    id: string;
    value: string;
    checked?: boolean;
}


@Component({
  selector: 'ui-multi-dropdown',
  templateUrl: './multi-dropdown.component.html',
  styleUrls: ['./multi-dropdown.component.less']
})
export class MultiDropdownComponent implements OnChanges {

    @Input() isDisabled: boolean;
    @Input() optionsList: IOptionItem[] = [];
    @Input() optionKeyToSelect: string;
    @Input() placeholderText = 'Select';
    @Input() noOptionsPlaceholder = 'No records found';
    @Input() isAllSelectedPlaceholderShown = true;
    @Input() filterInputPlaceholder = 'Search';
    @Input() showListOnTop = false;
    @Output() onSelected = new EventEmitter<string[]>();

    localOptionsList: IOptionItem[] = [];
    isOpened = false;

    get isAllChecked(): boolean {
        return this.localOptionsList.every((option: IOptionItem) => option.checked );
    }

    get isSomeChecked(): boolean {
        return this.localOptionsList.some((option: IOptionItem) => option.checked )
            && this.localOptionsList.some((option: IOptionItem) => !option.checked );
    }

    get selectedLength(): number {
        return this.localOptionsList.filter(i => i.checked ).length;
    }

    get hasFilteredResults(): boolean {
        return (!this.pipeFilterQuery.length)
            ? true
            : this.localOptionsList.some(option => option.value.toLowerCase().includes(this.pipeFilterQuery.toLowerCase()));
    }

    /**
     * filtering
     */
    @Input() enableFiltering = false;
    @Input() minQueryLength: number = 3;
    filterQuery = '';
    pipeFilterQuery = '';
    filterBy: Record<string, string> = null;

    @HostListener('document:click', ['$event.target']) clickedOutside(target: HTMLElement): void {
        if (!this.eRef.nativeElement.contains(target) && this.isOpened) {
            this.close();
        }
    }

    constructor(private eRef: ElementRef) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.hasOwnProperty('optionsList')) {
            this.mapOptionsList();
        }
    }

    toggle(): void {
        this.isOpened = !this.isOpened;

        if (this.isOpened) {
            this.mapOptionsList();
        }
    }

    close(): void {
        this.isOpened = false;
    }

    selectOption(): void {
        const output = this.localOptionsList
            .filter(opt => opt.checked)
            .map(opt => this.optionKeyToSelect && opt.hasOwnProperty(this.optionKeyToSelect)
                ? opt[this.optionKeyToSelect] : opt.id);
        this.onSelected.emit(output);
    }

    toggleAllChecked(): void {
        const IS_ALL_CHECKED: boolean = this.isSomeChecked ? true : !this.isAllChecked;
        this.localOptionsList.forEach((option: IOptionItem) => option.checked = IS_ALL_CHECKED);
    }

    setFilterQuery(query: string): void {
        const trimmedQuery: string = query.trim();
        if (!trimmedQuery.length) {
            this.filterQuery = '';
            this.pipeFilterQuery = '';
        }

        this.pipeFilterQuery = (trimmedQuery.length < this.minQueryLength) ? '' : trimmedQuery;
        this.filterBy = this.pipeFilterQuery.length ? { value: this.pipeFilterQuery } : null;
    }

    private mapOptionsList(): void {
        if (this.optionsList) {
            const checkedList: IOptionItem[] = this.optionsList.filter((option: IOptionItem) => option.checked);
            const notCheckedList: IOptionItem[] = this.optionsList.filter((option: IOptionItem) => !option.checked);
            this.localOptionsList = checkedList.concat(notCheckedList);
        }
    }
}
